import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { user, global } from '@/modules';
import { GlobalData } from '@/features';
import { useUpdate } from '@/hooks';
import { fallbackRender } from '@/features';

type GlobalHocProviderType = {
  children: React.ReactElement;
};

export const GlobalHocProvider = ({ children }: GlobalHocProviderType) => {
  const navigate = useNavigate();
  const [update] = useUpdate();
  const { t } = useTranslation();
  const userInfo = useSelector(user.selector.getUserInfoState);
  const appInfo = useSelector(global.selector.getAppInfo);

  const dispatch = useDispatch();

  if (userInfo.currentTeamId === '0') {
    return <div style={{ textAlign: 'center', color: 'red' }}>用户信息丢失， 不用进页面了~</div>;
  }

  if (appInfo && !Object.keys(appInfo).length && !location.pathname.includes('team')) {
    return <div>{fallbackRender()}</div>;
  }

  const value = {
    userInfo,
    dispatch,
    update,
    navigate,
    t,
    appInfo,
  };

  return <GlobalData.Provider value={value}>{children}</GlobalData.Provider>;
};
